<script lang="ts">
  import { srcAt } from "../support/graphics";
  import type { Page } from "../types";

  export let page: Page;

  $: [primaryLink, ...secondaryLinks] = page.pageLinks;
</script>

<main style="--background-color: {page.backgroundColor}">
  <div class="InnerContainer">
    {#if primaryLink}
      <a
        class="Link primary"
        class:graphical={primaryLink.thumbnail}
        href={primaryLink.url}
        style="--text-color: {primaryLink.textColor}; --background-color: {primaryLink.backgroundColor};"
      >
        {#if primaryLink.thumbnail}
          <div
            class="Thumbnail"
            style="--background-image: url({srcAt(primaryLink.thumbnail, 800)})"
          ></div>
        {/if}

        {#if primaryLink.name}
          <footer class="LinkFooter" class:sr-only={!primaryLink.showLabel}>
            {primaryLink.name}
          </footer>
        {/if}
      </a>
    {/if}

    <div class="SecondaryLinks">
      {#each secondaryLinks as link}
        <a
          class="Link secondary"
          href={link.url}
          class:graphical={link.thumbnail}
          style="--text-color: {link.textColor}; --background-color: {link.backgroundColor};"
        >
          {#if link.thumbnail}
            <div
              class="Thumbnail"
              style="--background-image: url({srcAt(link.thumbnail, 400)})"
            ></div>
          {/if}

          {#if link.name}
            <footer class="LinkFooter" class:sr-only={!link.showLabel}>
              {link.name}
            </footer>
          {/if}
        </a>
      {/each}
    </div>
  </div>
</main>

<style>
  main {
    --grid-gap: calc(var(--sp) * 16);
    background: var(--background-color, white);
    flex: 1 1 auto;
    hyphens: auto;
    overflow: auto;
    padding-top: max(env(safe-area-inset-top), var(--grid-gap));
    padding-left: max(env(safe-area-inset-left), var(--grid-gap));
    padding-right: max(env(safe-area-inset-right), var(--grid-gap));
    padding-bottom: max(env(safe-area-inset-bottom), var(--grid-gap));
    width: 100%;
  }

  .InnerContainer {
    flex: 1 1 auto;
    margin: 0 auto;
    max-width: 480px;
    width: 100%;
  }

  .Link {
    background-color: var(--background-color, #000);
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
    color: var(--text-color, #fff);
    display: flex;
    font-size: 16px;
    line-height: 1.33;
    font-weight: 600;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    text-decoration: none;
    text-align: center;
  }

  .Link.primary {
    align-items: flex-end;
    aspect-ratio: 320 / 240;
    background-color: var(--background-color, #000);
    margin-bottom: var(--grid-gap);
  }

  .Link.graphical {
    font-size: 16px;
  }

  .Link.secondary {
    aspect-ratio: 1 / 1;
  }

  .Thumbnail {
    background-image: var(--background-image);
    background-size: cover;
    background-position: 50% 50%;
    display: block;
    flex: 1 1;
    width: 100%;
  }

  .LinkFooter {
    align-items: center;
    background-color: var(--background-color, #000);
    display: flex;
    flex: 0 0;
    justify-content: center;
    padding: 20px;
    width: 100%;
  }

  .SecondaryLinks {
    display: grid;
    grid-gap: var(--grid-gap);
    grid-template-columns: repeat(2, 1fr);
  }
</style>
